import {
  MARKETING_PARAM_KEYS,
  MarketingParamKey,
  TW_REFERRER_KEY,
} from './constants'

const MARKETING_PARAM_KEY_BY_LOWER = new Map<string, MarketingParamKey>(
  MARKETING_PARAM_KEYS.map((key) => [key.toLowerCase(), key])
)

const PERSISTED_KEY_LOWER_SET = new Set(
  [...MARKETING_PARAM_KEYS, TW_REFERRER_KEY].map((key) => key.toLowerCase())
)

export function normalizeMarketingParamKey(
  rawKey: string
): MarketingParamKey | null {
  return MARKETING_PARAM_KEY_BY_LOWER.get(rawKey.toLowerCase()) ?? null
}

export function normalizeTwReferrerKey(rawKey: string): boolean {
  return rawKey.toLowerCase() === TW_REFERRER_KEY.toLowerCase()
}

export function isPersistedParamKey(rawKey: string): boolean {
  return PERSISTED_KEY_LOWER_SET.has(rawKey.toLowerCase())
}

export function getParamCaseInsensitive(
  params: URLSearchParams,
  canonicalKey: string
): string | null {
  const target = canonicalKey.toLowerCase()
  let found: string | null = null

  params.forEach((value, key) => {
    if (found === null && key.toLowerCase() === target) {
      found = value
    }
  })

  return found
}

export function hasParamCaseInsensitive(
  params: URLSearchParams,
  canonicalKey: string
): boolean {
  return getParamCaseInsensitive(params, canonicalKey) !== null
}

export function deleteParamCaseInsensitive(
  params: URLSearchParams,
  canonicalKey: string
): void {
  const target = canonicalKey.toLowerCase()
  const keysToDelete: string[] = []

  params.forEach((_, key) => {
    if (key.toLowerCase() === target) {
      keysToDelete.push(key)
    }
  })

  keysToDelete.forEach((key) => {
    params.delete(key)
  })
}
